export default {"src":"/_next/static/media/Facebook-Icon.2490ee38.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};